export default __webpack_public_path__ + "static/media/illogic.e42377fc.png";